import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_grid_table_cell = _resolveComponent("grid-table-cell")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_grid_table_row = _resolveComponent("grid-table-row")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_grid_table_leaf = _resolveComponent("grid-table-leaf")
  const _component_grid_table = _resolveComponent("grid-table")

  return (_openBlock(), _createBlock(_component_grid_table, {
    class: "flex grow",
    "data-qa": `group-table:${$props.tableTitle}`
  }, {
    head: _withCtx(() => [
      _createVNode(_component_grid_table_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_grid_table_cell, { width: $props.prefixColumnWidth }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode(" # ", -1 /* CACHED */)
            ]))]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["width"]),
          _createVNode(_component_grid_table_cell, { width: $props.prefixColumnWidth }, {
            default: _withCtx(() => [
              _createVNode(_component_base_icon, {
                name: $options.groupCollapsedComputedIconName,
                onClick: $options.toggleAllRows
              }, null, 8 /* PROPS */, ["name", "onClick"])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["width"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.headers, (header, index) => {
            return (_openBlock(), _createBlock(_component_grid_table_cell, {
              key: header,
              "text-align": $props.textAlignments[index],
              width: $props.widths[index]
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(header), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["text-align", "width"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      })
    ]),
    body: _withCtx(() => [
      ($options.hasGroups)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($props.groups, (group, groupIndex) => {
            return (_openBlock(), _createElementBlock("div", {
              key: group.groupName
            }, [
              _createVNode(_component_grid_table_row, {
                "is-clickable": true,
                onClick: $event => ($options.toggleRow(group.groupName))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_grid_table_cell, {
                    "table-cell": "",
                    width: $props.prefixColumnWidth
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(groupIndex + 1), 1 /* TEXT */)
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["width"]),
                  _createVNode(_component_grid_table_cell, { width: $props.prefixColumnWidth }, {
                    default: _withCtx(() => [
                      _createVNode(_component_base_icon, {
                        name: $options.computedIconName(group.groupName)
                      }, null, 8 /* PROPS */, ["name"])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["width"]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.groupData, (cell, index) => {
                    return (_openBlock(), _createBlock(_component_grid_table_cell, {
                      key: `group-header-content-cell:${index}`,
                      "text-align": $props.textAlignments[index],
                      width: $props.widths[index]
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(cell.title) + " ", 1 /* TEXT */),
                        (cell.tooltip)
                          ? (_openBlock(), _createBlock(_component_tooltip, {
                              key: 0,
                              text: cell.tooltip
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_base_icon, { name: "circle-info" })
                              ]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["text"]))
                          : _createCommentVNode("v-if", true)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["text-align", "width"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
              ($options.isRowExpanded(group.groupName))
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(group.groupEntries, (source, groupIndex) => {
                    return (_openBlock(), _createBlock(_component_grid_table_row, {
                      key: groupIndex,
                      class: "_pb-0 _ba-0"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_grid_table_cell, {
                          width: 2*$props.prefixColumnWidth
                        }, {
                          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                            _createElementVNode("span", null, null, -1 /* CACHED */)
                          ]))]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["width"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(source, (cell, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            (index === $data.leafIndex)
                              ? (_openBlock(), _createBlock(_component_grid_table_leaf, {
                                  key: `table-content-leaf:${index}`,
                                  "is-last-leaf": groupIndex === group.groupEntries.length - 1,
                                  "text-align": $props.textAlignments[index],
                                  width: $props.widths[index]
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(cell), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["is-last-leaf", "text-align", "width"]))
                              : (_openBlock(), _createBlock(_component_grid_table_cell, {
                                  key: `table-content-cell:${index}`,
                                  "text-align": $props.textAlignments[index],
                                  width: $props.widths[index]
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(cell), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["text-align", "width"]))
                          ], 64 /* STABLE_FRAGMENT */))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */))
                  }), 128 /* KEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        : (_openBlock(), _createBlock(_component_grid_table_row, {
            key: 1,
            "is-filled": true
          }, {
            default: _withCtx(() => [
              _createVNode(_component_grid_table_cell, { "is-empty": true }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("There is no data to show", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }))
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["data-qa"]))
}